import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "../../../../../OW.Remoting/Remoting/AttrValueReader";
import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ItemTemplate } from "../ItemTemplate";

export class LOVTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        // v needitaci sem prijde pole primitivnich hodnot, ktere se maji rovnou zobrazit
        // v editaci (a pri oznaceni radku) sem prijde pole s jednim prvkem, ktery je OWObject
        if (dataSet === undefined || !(dataSet instanceof Array) || dataSet.length === 0 || (dataSet.length === 1 && (dataSet[0] === undefined || AttrValueReader.read(dataSet[0]) === undefined))) // chyba dat
            return;

        if (dataSet[0] || dataSet.length > 1)
            item.innerHTML = await this.parentColumn.formatValue(dataSet);
        else
            item.innerHTML = "";
    }

    protected override _createContentElement(): HTMLElement {
        if (this.parentColumn.isEditable) {
            return createElement({ type: "span" });
        }

        const innerElement = createElement({ type: "a", classes: "lovTemplate", attrs: { "role": "button" } });
        innerElement.addEventListener("click", () => {
            this.parentColumn.callEvent("openDetailForm", {
                id: innerElement.closest(".DataRow").getAttribute("datakey"),
            });
        });
        return innerElement;
    }
}
